"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_client_service_1 = require("../../../../axios-client/axios-client.service");
var user_company_user_notification_channels_const_1 = require("./user-company-user-notification-channels.const");
/**
 * UserCompanyUserNotificationChannel
 * @class
 */
var UserCompanyUserNotificationChannel = /** @class */ (function () {
    function UserCompanyUserNotificationChannel() {
    }
    /**
     * Binds a new notification channel to a user (`userUuid`)
     * @param userUuid {string}
     * @param data <Channel>
     * @returns
     */
    UserCompanyUserNotificationChannel.prototype.createUserNotificationChannel = function (userUuid, data, version) {
        if (version === void 0) { version = 'v1'; }
        var url = user_company_user_notification_channels_const_1.USER_COMPANY_USER_NOTIFICATION_CHANNELS_ENDPOINT.createUserNotificationChannel
            .replace('{{version}}', version)
            .replace('{{userUuid}}', userUuid);
        return axios_client_service_1.axiosClientInstance.post(url, data);
    };
    /**
     * Binds a new notification channel to a profile (`userProfileUuid`)
     * @param userProfileUuid {string}
     * @param data <Channel>
     * @returns
     */
    UserCompanyUserNotificationChannel.prototype.createProfileNotificationChannel = function (userProfileUuid, version) {
        if (version === void 0) { version = 'v1'; }
        var url = user_company_user_notification_channels_const_1.USER_COMPANY_USER_NOTIFICATION_CHANNELS_ENDPOINT.createProfileNotificationChannel
            .replace('{{version}}', version)
            .replace('{{userProfileUuid}}', userProfileUuid);
        return axios_client_service_1.axiosClientInstance.post(url);
    };
    /**
     * Updates a value of a notification channel of a user by channel id (`notificationChannelUuid`)
     * @param notificationChannelUuid {string}
     * @param data <Channel>
     * @returns
     */
    UserCompanyUserNotificationChannel.prototype.updateUserNotificationChannel = function (notificationChannelUuid, data, version) {
        if (version === void 0) { version = 'v1'; }
        var url = user_company_user_notification_channels_const_1.USER_COMPANY_USER_NOTIFICATION_CHANNELS_ENDPOINT.updateUserNotificationChannel
            .replace('{{version}}', version)
            .replace('{{notificationChannelUuid}}', notificationChannelUuid);
        return axios_client_service_1.axiosClientInstance.post(url, data);
    };
    return UserCompanyUserNotificationChannel;
}());
/**
 * External UserCompanyUserNotificationChannel Class Instance
 * @namespace
 */
exports.userCompanyUserNotificationChannel = new UserCompanyUserNotificationChannel();
